import { useContext, useEffect, useState } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { InfoContext } from '../components/context';
import { getMaildataList, postAttachment, postMaildata } from '../js/api-service';
import FileList from './custom/FileList';


export default function Upload() {

    const { session, parterList, formFiles, name, updateFormFiles, personNumber, setData, setMailData, unAuthorizedFiles } = useContext(InfoContext);
    const [comment, setComment] = useState("");
    const [completeMessage, setCompleteMessage] = useState(false);
    const [failMessage, setFailMessage] = useState(false);
    const [loading, setloading] = useState(false);
    let { id } = useParams();
    let item = parterList?.find(p => p.claimNumber === id);
    const navigate = useNavigate();

    useEffect(() => {
        document.body.scrollTop = document.documentElement.scrollTop = 0;
    }, [])

    useEffect(() => {
        setFailMessage(false);
    }, [formFiles, comment])

    const ignoreTimeOffset = () => {
        const timeZoneOffset = (new Date()).getTimezoneOffset() * 60000;
        const localIsoTime = (new Date(Date.now() - timeZoneOffset)).toISOString().slice(0, -1);
        return localIsoTime;
    }

    const handleUploadSubmit = async (event) => {

        event.preventDefault();
        let maildataResult = "", attachmentResult = "";
        if (comment === "") {
            setFailMessage(true);
            return;
        }
        setloading(true);
        setFailMessage(false);
        const date = ignoreTimeOffset();
        // const envelopId = `${session.split("-")[0]}${new Date().valueOf()}`;
        const countAttchment = formFiles ? Array.from(formFiles).filter(file => !unAuthorizedFiles.includes(file.name.split(".").pop())).length : 0
        const maildata = {
            DelegateTo: parseInt(item?.adjusterID),
            DateInserted: date,
            DateReceived: date,
            DateSent: date,
            MailFrom: personNumber,
            MailTo: "",
            Mailsubject: `Rekisteröity Crawfordin portaaliin`,
            Body: comment,
            Direction: 'In',
            DocType: 'webopplastning',
            SystemId: item?.systemID,
            BodyFormat: 1,
            CountAttachment: countAttchment,
            InternalComment: session,
            Claimid: item?.claimNumber,
            PartyName: name,
            Client: ""
        };
        try {
            maildataResult = await postMaildata(session, maildata);
        } catch {
            navigate("/fail");
        }
        if (formFiles && formFiles?.length > 0) {
            let files = Array.from(formFiles);
            for (let index = 0; index < files.length; index++) {
                const fileElement = files[index];
                try {
                    if (!unAuthorizedFiles.includes(fileElement.name.split(".").pop())) {
                        attachmentResult = await postAttachment(session, fileElement, session);
                    }
                } catch {
                    navigate("/fail");
                }
            }
            updateFormFiles([]);
        }

        const mailDataList = await getMaildataList(session);
        setData(mailDataList?.data)
        let newMailData = mailDataList?.data?.map(res => res.maildata);
        setMailData(newMailData);

        if (maildataResult !== "") setCompleteMessage(true);
        setloading(false);
    }

    return (
        <>
            {loading && <div className="loading" aria-label="Odota hetki."></div>}
            {!loading && !completeMessage ?
                <>
                    <h3 className="medium-header margin-top__large" >Voit lähettää viestin ja ladata asiakirjoja</h3 >
                    <form name='claimForm' onSubmit={(event) => { handleUploadSubmit(event) }}>
                        <div>
                            <label className="input-label">
                                <span className='required'>Kirjoita viestisi</span>
                                <textarea name="comment" placeholder="Kirjoita viestisi" onChange={(event) => { setComment(event.target.value.trim()) }} ></textarea>
                            </label>
                        </div>
                        <p>Klikkaa valitaksesi tiedostoja tai raahaa tiedostot ikkunaan</p>
                        <FileList item={{ text: "Valitse tiedosto", name: "attachments", required: false, multiple: true }} />
                        {failMessage && <p className='error-message margin-top__large' aria-live='polite'>Sinun täytyy kirjoittaa teksti</p>}
                        <button type='submit' className='submit-button margin-top__large padding-small'>Lähetä</button>
                    </form >
                </>
                :
                <h3 className="medium-header margin-top__large" >Kiitos viestistäsi!</h3>
            }
            {!loading && <div className="link-block">
                <Link to="/">Palaa takaisin</Link>
            </div>
            }
        </>
    )

}